export const themeColors = {
  /* Font Weights */
  "--hv-font-weight-regular": "var(--hv-font-weight-regular)",
  "--hv-font-weight-medium": "var(--hv-font-weight-medium)",
  "--hv-font-weight-semibold": "var(--hv-font-weight-semibold)",
  "--hv-font-weight-bold": "var(--hv-font-weight-bold)",

  /* Radius */
  "--hv-radius-none": "var(--hv-radius-none)",
  "--hv-radius-xs": "var(--hv-radius-xs)",
  "--hv-radius-sm": "var(--hv-radius-sm)",
  "--hv-radius-md": "var(--hv-radius-md)",
  "--hv-radius-lg": "var(--hv-radius-lg)",
  "--hv-radius-xl": "var(--hv-radius-xl)",

  /* Spacing */
  "--hv-spacing-none": "var(--hv-spacing-none)",
  "--hv-spacing-1": "var(--hv-spacing-1)",
  "--hv-spacing-2": "var(--hv-spacing-2)",
  "--hv-spacing-3": "var(--hv-spacing-3)",
  "--hv-spacing-4": "var(--hv-spacing-4)",
  "--hv-spacing-5": "var(--hv-spacing-5)",
  "--hv-spacing-6": "var(--hv-spacing-6)",
  "--hv-spacing-7": "var(--hv-spacing-7)",
  "--hv-spacing-8": "var(--hv-spacing-8)",
  "--hv-spacing-9": "var(--hv-spacing-9)",
  "--hv-spacing-10": "var(--hv-spacing-10)",
  "--hv-spacing-full": "var(--hv-spacing-full)",

  /* Font Sizes */
  "--hv-fontsize-body-xs": "var(--hv-fontsize-body-xs)",
  "--hv-fontsize-body-sm": "var(--hv-fontsize-body-sm)",
  "--hv-fontsize-body-md": "var(--hv-fontsize-body-md)",
  "--hv-fontsize-body-lg": "var(--hv-fontsize-body-lg)",
  "--hv-fontsize-headline-2xs": "var(--hv-fontsize-headline-2xs)",
  "--hv-fontsize-headline-xs": "var(--hv-fontsize-headline-xs)",
  "--hv-fontsize-headline-sm": "var(--hv-fontsize-headline-sm)",
  "--hv-fontsize-headline-md": "var(--hv-fontsize-headline-md)",
  "--hv-fontsize-headline-lg": "var(--hv-fontsize-headline-lg)",
  "--hv-fontsize-headline-xl": "var(--hv-fontsize-headline-xl)",

  /* Line Height */
  "--hv-lineheight-body-xs": "var(--hv-lineheight-body-xs)",
  "--hv-lineheight-body-sm": "var(--hv-lineheight-body-sm)",
  "--hv-lineheight-body-md": "var(--hv-lineheight-body-md)",
  "--hv-lineheight-body-lg": "var(--hv-lineheight-body-lg)",
  "--hv-lineheight-headline-2xs": "var(--hv-lineheight-headline-2xs)",
  "--hv-lineheight-headline-xs": "var(--hv-lineheight-headline-xs)",
  "--hv-lineheight-headline-sm": "var(--hv-lineheight-headline-sm)",
  "--hv-lineheight-headline-md": "var(--hv-lineheight-headline-md)",
  "--hv-lineheight-headline-lg": "var(--hv-lineheight-headline-lg)",
  "--hv-lineheight-headline-xl": "var(--hv-lineheight-headline-xl)",

  /* Colors (Light Theme) */
  "--hv-white": "var(--hv-white)",
  "--hv-black": "var(--hv-black)",
  "--hv-surface": "var(--hv-surface)",
  "--hv-surface-widget": "var(--hv-surface-widget)",
  "--hv-surface-popup": "var(--hv-surface-popup)",
  "--hv-surface-popup-panel": "var(--hv-surface-popup-panel)",
  "--hv-surface-modal": "var(--hv-surface-modal)",

  /* Interaction */
  "--hv-interaction-hover": "var(--hv-interaction-hover)",
  "--hv-interaction-press": "var(--hv-interaction-press)",
  "--hv-interaction-select-gray": "var(--hv-interaction-select-gray)",
  "--hv-interaction-select-orange": "var(--hv-interaction-select-orange)",

  /* Brand */
  "--hv-brand-primary": "var(--hv-brand-primary)",

  /* Data */
  "--hv-data-blue": "var(--hv-data-blue)",
  "--hv-data-red": "var(--hv-data-red)",
  "--hv-data-gray": "var(--hv-data-gray)",
  "--hv-data-green": "var(--hv-data-green)",
  "--hv-data-yellow": "var(--hv-data-yellow)",
  "--hv-data-sapphire": "var(--hv-data-sapphire)",
  "--hv-data-orange": "var(--hv-data-orange)",
  "--hv-data-emerald": "var(--hv-data-emerald)",
  "--hv-data-coral": "var(--hv-data-coral)",
  "--hv-data-indigo": "var(--hv-data-indigo)",
  "--hv-data-purple": "var(--hv-data-purple)",
  "--hv-data-violet": "var(--hv-data-violet)",
  "--hv-data-pink": "var(--hv-data-pink)",

  /* Primary Button */
  "--hv-button-primary-default": "var(--hv-button-primary-default)",
  "--hv-button-primary-hover": "var(--hv-button-primary-hover)",
  "--hv-button-primary-press": "var(--hv-button-primary-press)",
  "--hv-button-primary-disabled": "var(--hv-button-primary-disabled)",

  /* Secondary Button */
  "--hv-button-secondary-default": "var(--hv-button-secondary-default)",
  "--hv-button-secondary-hover": "var(--hv-button-secondary-hover)",
  "--hv-button-secondary-press": "var(--hv-button-secondary-press)",
  "--hv-button-secondary-disabled": "var(--hv-button-secondary-disabled)",

  /* Tertiary Button */
  "--hv-button-tertiary-hover": "var(--hv-button-tertiary-hover)",
  "--hv-button-tertiary-press": "var(--hv-button-tertiary-press)",
  "--hv-button-tertiary-outline-default":
    "var(--hv-button-tertiary-outline-default)",

  /* Ghost Button */
  "--hv-button-ghost-hover": "var(--hv-button-ghost-hover)",
  "--hv-button-ghost-press": "var(--hv-button-ghost-press)",
  "--hv-button-ghost-disabled": "var(--hv-button-ghost-disabled)",

  /* Normal Icon */
  "--hv-icon-normal-primary": "var(--hv-icon-normal-primary)",
  "--hv-icon-normal-secondary": "var(--hv-icon-normal-secondary)",
  "--hv-icon-normal-tertiary": "var(--hv-icon-normal-tertiary)",
  "--hv-icon-normal-disabled": "var(--hv-icon-normal-disabled)",

  /* On-Brand Icon */
  "--hv-icon-on-brand-primary": "var(--hv-icon-on-brand-primary)",
  "--hv-icon-on-brand-secondary": "var(--hv-icon-on-brand-secondary)",
  "--hv-icon-on-brand-tertiary": "var(--hv-icon-on-brand-tertiary)",
  "--hv-icon-on-brand-disabled": "var(--hv-icon-on-brand-disabled)",

  /* Normal Text */
  "--hv-text-normal-primary": "var(--hv-text-normal-primary)",
  "--hv-text-normal-secondary": "var(--hv-text-normal-secondary)",
  "--hv-text-normal-tertiary": "var(--hv-text-normal-tertiary)",
  "--hv-text-normal-disabled": "var(--hv-text-normal-disabled)",

  /* On-Brand Text */
  "--hv-text-on-brand-primary": "var(--hv-text-on-brand-primary)",
  "--hv-text-on-brand-secondary": "var(--hv-text-on-brand-secondary)",
  "--hv-text-on-brand-tertiary": "var(--hv-text-on-brand-tertiary)",
  "--hv-text-on-brand-disabled": "var(--hv-text-on-brand-disabled)",

  /* Input Foreground Colors */
  "--hv-input-foreground-default": "var(--hv-input-foreground-default)",
  "--hv-input-foreground-hover": "var(--hv-input-foreground-hover)",
  "--hv-input-foreground-press": "var(--hv-input-foreground-press)",
  "--hv-input-foreground-disabled": "var(--hv-input-foreground-disabled)",

  /* Input Outline Colors */
  "--hv-input-outline-active": "var(--hv-input-outline-active)",
  "--hv-input-outline-default": "var(--hv-input-outline-default)",
  "--hv-input-outline-hover": "var(--hv-input-outline-hover)",
  "--hv-input-outline-press": "var(--hv-input-outline-press)",

  /* Border Colors */
  "--hv-border-default": "var(--hv-border-default)",
  "--hv-border-emphasis": "var(--hv-border-emphasis)",

  /* Scroll Colors */
  "--hv-scroll-default": "var(--hv-scroll-default)",
  "--hv-scroll-hover": "var(--hv-scroll-hover)",

  /* Table Header Colors */
  "--hv-table-header-default": "var(--hv-table-header-default)",

  /* Loading Colors */
  "--hv-loading-circuit-ring-default": "var(--hv-loading-circuit-ring-default)",
  "--hv-loading-spinner-primary": "var(--hv-loading-spinner-primary)",
  "--hv-loading-spinner-secondary": "var(--hv-loading-spinner-secondary)",

  /* Alert Colors */
  "--hv-alert-text-default": "var(--hv-alert-text-default)",
  "--hv-alert-icon-default": "var(--hv-alert-icon-default)",
  "--hv-alert-background-default": "var(--hv-alert-background-default)",

  /* Snack Bar Colors */
  "--hv-snack-bar-text-default": "var(--hv-snack-bar-text-default)",
  "--hv-snack-bar-icon-default": "var(--hv-snack-bar-icon-default)",
  "--hv-snack-bar-icon-hover": "var(--hv-snack-bar-icon-hover)",
  "--hv-snack-bar-icon-press": "var(--hv-snack-bar-icon-press)",
  "--hv-snack-bar-background-default": "var(--hv-snack-bar-background-default)",

  /* Tooltip Colors */
  "--hv-tooltip-background": "var(--hv-tooltip-background)",

  /* Dropdown Colors */
  "--hv-options-backgound-color": "var(--hv-options-backgound-color)",
  "--hv-options-border-color": "var(--hv-options-border-color)",

  /* Avatar Colors */
  "--hv-avatar-background-primary-top":
    "var(--hv-avatar-background-primary-top)",
  "--hv-avatar-background-primary-bottom":
    "var(--hv-avatar-background-primary-bottom)",
  "--hv-avatar-background-secondary-top":
    "var(--hv-avatar-background-secondary-top)",
  "--hv-avatar-background-secondary-bottom":
    "var(--hv-avatar-background-secondary-bottom)",
  "--hv-avatar-text-primary": "var(--hv-avatar-text-primary)",
  "--hv-avatar-text-secondary": "var(--hv-avatar-text-secondary)",

  /* Toggle Colors */
  "--hv-toggle-default": "var(--hv-toggle-default)",
  "--hv-toggle-selected-green": "var(--hv-toggle-selected-green)",
  "--hv-toggle-selected-orange": "var(--hv-toggle-selected-orange)",
  "--hv-toggle-disabled": "var(--hv-toggle-disabled)",
  "--hv-toggle-handle": "var(--hv-toggle-handle)",

  /* PI Logo Colors */
  "--hv-pi-logo-orange": "var(--hv-pi-logo-orange)",
  "--hv-pi-logo-intersection": "var(--hv-pi-logo-intersection)",
  "--hv-pi-logo-gray": "var(--hv-pi-logo-gray)",
  "--hv-pi-logo-left": "var(--hv-pi-logo-left)",
  "--hv-pi-logo-intersection-gray": "var(--hv-pi-logo-intersection-gray)",
  "--hv-pi-logo-right": "var(--hv-pi-logo-right)",

  /* Shadows */
  "--hv-shadow-1": "var(--hv-shadow-1)",
  "--hv-shadow-2": "var(--hv-shadow-2)",
  "--hv-shadow-3": "var(--hv-shadow-3)",
  "--hv-shadow-4": "var(--hv-shadow-4)",
  "--hv-shadow-5": "var(--hv-shadow-5)",
  "--hv-shadow-6": "var(--hv-shadow-6)",
};
